import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
/* -- biz9 import start -- */
import {Str} from "biz9-utility";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Item_Setting_Edit = (props) => {

    const [sel_setting_visible,setSelSettingVisible] = useState(null);
    const option_visibles = [{ value: "0", label: "False" }, { value: "1", label: "True" }];

    const [sel_setting_delete_protection,setSelSettingDeleteProtection] = useState({value: "0",label:"False"});
    const option_delete_protections = [{ value: '1', label: 'True' }, { value: '0', label: 'False' }];

    const [val_id,setValId] = useState('');
    const [val_title_url,setValTitleUrl] = useState('');

    useEffect(() => {
      bind_field(props.item);
    },[props]);
    async function bind_field(item) {
        setSelSettingVisible(option_visibles.find(option => option.value === item.setting_visible));
        setSelSettingDeleteProtection(option_delete_protections.find(option => option.value === item.setting_delete_protection));
        setValId(item.id);
        setValTitleUrl(item.title_url);
    };
 const handle_submit = (event) => {
        event.preventDefault();
    };
    const updateSelSettingVisible = (selectedOption) => {
        setSelSettingVisible(selectedOption);
        props.onItemUpdate(props.item,Field.SETTING_VISIBLE,selectedOption.value);
    };
    const updateSelSettingDeleteProtection = (selectedOption) => {
        setSelSettingDeleteProtection(selectedOption);
        props.onItemUpdate(props.item,Field.SETTING_DELETE_PROTECTION,selectedOption.value);
    };
    return (
<div className="settings-card">
<div className="settings-card-head bg-light">
<h4>{Title.LABEL_SETTING}</h4>
</div>
<form onSubmit={handle_submit}>
<div className="settings-card-body">
		<div className="row">
<div className="col-md-4">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Visible
</label>
<Select classNamePrefix="react-select" className="select" styles={Style.customStyles} onChange={updateSelSettingVisible} value={sel_setting_visible} options={option_visibles} placeholder="Select an option" />
</div>
</div>
<div className="col-md-4">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Delete Protection
</label>
<Select classNamePrefix="react-select" className="select" styles={Style.customStyles}  onChange={updateSelSettingDeleteProtection} value={sel_setting_delete_protection} options={option_delete_protections} placeholder="Select an option" />
</div>
</div>
<div className="col-md-8">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
{Title.LABEL_KEY}
</label>
<input value={val_title_url} disabled={true} className="form-control" />
</div>
</div>
<div className="col-md-8">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
{Title.LABEL_ID}
</label>
<input value={val_id} disabled={true} className="form-control" />
</div>
</div>
</div>
</div>
</form>
</div>
);
};
export default Item_Setting_Edit;
